import { Spinner, Text } from '@shopify/polaris';

const Loading = () => (
  <div style={{ display: 'flex', justifyContent: 'center', padding: '2em 0' }}>
    <span style={{ paddingRight: '5px' }}>
      <Text variant="headingSm" as="h6">
        Cargando...{' '}
      </Text>
    </span>
    <Spinner size="small" />
  </div>
);

export default Loading;
